module.exports = __webpack_public_path__ + "img/documents-sarah_atestados.bbf3bd04.svg";